import React from 'react'

function CardsContainer(name) {
    return (
        <div>
            <h1>{name}</h1>
        </div>
    )
}

export default CardsContainer
